
import {Card, Col, Empty, Image, Row} from "antd";
import {useEffect, useState} from "react";
import {Button, Loading} from "../../../components";
import {useParams} from "react-router-dom";
import {apiError, handleRequest, renderDate} from "../../../utils";
import {promotionApi} from "../../../api";
import DOMPurify from "dompurify";
import style from "../style/Promotion.module.scss";
import className from 'classnames/bind';
const cn = className.bind(style);
function PromotionDetail()
{
    const {id} = useParams();

    const [loading, setLoading] = useState(true);

    const [errorLoad, setErrorLoad] = useState(false);

    const [promotion, setPromotion] = useState({});

    const TitleComponent = () => {
        return <><span className={'color-red'}>{promotion.name}</span></>
    }

    const eventsHandler = {
        load: async () => {

            let [error, response] = await handleRequest(promotionApi.detail({
                id: id
            }));

            let message = apiError(`Load chương trình thất bại`, error, response);

            if (!message)
            {
                setPromotion(response.data);
                setErrorLoad(false)
            }
            else
            {
                setErrorLoad(true);
            }

            setLoading(false);
        },
    }

    useEffect(() => {
        eventsHandler.load().then()
    }, [id])

    if(loading) {
        return (
            <div className="container">
                <Loading/>
            </div>
        )
    }

    if(errorLoad) {
        return (
            <div className="container">
                <Empty description={<span>Không có chương trình</span>}><Button to={'/promotion'}>Quay lại danh sách chương trình khuyến mãi</Button></Empty>
            </div>
        )
    }

    return (
        <>
            <div className="container d-block">
                <div className="content pd-2" style={{overflow: 'auto'}}>
                    <Row gutter={16} className="mb-2">
                        <Col className="gutter-row" span={4}>
                            <Card>
                                <p>Mã chương trình</p>
                                <b>KM{promotion.id}</b>
                            </Card>
                        </Col>

                        <Col className="gutter-row" span={5}>
                            <Card>
                                <p>Thời gian bắt đầu</p>
                                {renderDate(promotion.timeStart)}
                            </Card>
                        </Col>
                        <Col className="gutter-row" span={5}>
                            <Card>
                                <p>Thời gian kết thúc</p>
                                {renderDate(promotion.timeEnd)}
                            </Card>
                        </Col>
                        <Col className="gutter-row" span={5}>
                            <Card>
                                <p>Ngày tạo</p>
                                {promotion.created}
                            </Card>
                        </Col>
                    </Row>
                    <Card title={<TitleComponent />}>
                        <Row gutter={16} className={cn('detail', 'mb-2')}>
                            <Col className="gutter-row" span={4}>
                                <Image src={promotion.image} preview={false} />
                            </Col>
                            <Col className="gutter-row" span={20}>
                                <div style={{wordBreak : 'break-all'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(promotion.content) }} />
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        </>
    )
}

export default PromotionDetail;